<template>
	
	<h2>Date</h2>
	<h3 class="text-with-icon">
			<svg width="24" height="24" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M12 7L12 13" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M12 17.01L12.01 16.9989" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
			</svg> 
			Emergency Orders or orders within the next 24 hours should be called in for the fastest response.
	</h3>

	<h3 class="text-with-icon">
			<svg width="24" height="24" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M12 7L12 13" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M12 17.01L12.01 16.9989" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
			</svg> 
			Only select the dates you plan to work.
	</h3>

	<p class="yellow">Note: Dates displayed in yellow reflect weekends and holidays.</p>

	<FatPickr 
		v-model:value="fields.date.datesOfWork"
		label="Date(s) Of Work"
		name="datesOfWork"
		:alwaysVisible="true"
		:required="true" 
		:holidayArr="[
			'2024-01-15', '2024-02-19', '2024-05-27', '2024-06-19', '2024-07-04', 
			'2024-09-02', '2024-10-14', '2024-11-11', '2024-11-28', '2024-12-24', 
			'2024-12-25', '2024-12-31', '2025-01-20', '2025-02-17', '2025-05-26', 
			'2025-06-19', '2025-07-04', '2025-09-01', '2025-10-13', '2025-11-11', 
			'2025-11-27', '2025-12-24', '2025-12-25', '2025-12-31', '2026-01-19',
			'2026-02-16', '2026-05-25', '2026-06-19', '2026-07-04', '2026-09-07', 
			'2026-10-12', '2026-11-11', '2026-11-26', '2026-12-24', '2026-12-25', 
			'2026-12-31'
		]"	
	/>

	<TimePicker 
		name="startTime"
		label="Start Time"
		:required="true"
		v-model:value="fields.date.startTime" />

	<TimePicker 
		name="endTime"
		label="End Time"
		:required="true"
		v-model:value="fields.date.endTime" />

	<TextArea 
		name="dateNotes"
		label="Date/Time Notes"
		placeholder="Different start/end times on certain days, etc"
		v-model:value="fields.date.dateNotes" />

	<ContinueBtn to="/scope-of-work" :isVisible="showBtn" />

</template>

<script>
import TimePicker from '@/components/TimePicker.vue'
import ContinueBtn from '@/components/ContinueBtn.vue'
import FatPickr from '@/components/FatPickr.vue'
import TextArea from '@/components/TextArea.vue'
import { mapState } from 'vuex'

export default {
	components: {
		FatPickr,
		TimePicker,
		ContinueBtn,
		TextArea
	},
	props: {
		showContinue: Boolean
	},
	data() {
		return {
			fieldsToCheck: ['date.datesOfWork', 'date.startTime', 'date.endTime']
		}
	},
	computed: {
		...mapState(['fields']),
		showBtn(){
			let showBtn = true

			if(this.fields.date.datesOfWork === '') showBtn = false
			if(this.fields.date.startTime === '') showBtn = false
			if(this.fields.date.endTime === '') showBtn = false

			return showBtn
		}
	},
	mounted(){
		this.$store.commit('addRoute', 1)
	}
}
</script>

<style scoped>
.text-with-icon { margin-bottom: 10px; }
</style>